var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0 9.563a.75.75 0 100 1.5.75.75 0 000-1.5zm0-6.376a.75.75 0 00-.75.75v4.125a.75.75 0 001.5 0V4.439a.75.75 0 00-.75-.75z",
    fill: "#FF3164"
  })));
}
export default __webpack_public_path__ + "static/warn.7c5c1898.svg";
export { SvgWarn as ReactComponent };